const debounce = (fn, wait) => {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn.apply(this, args), wait);
  };
};

class AnimateScroll extends HTMLElement {
  constructor() {
    super();

    if (!this.hasSupport) return;

    this.init = () => {
      const parent = this.parentElement;
      if (!parent) return;

      const { top, height } = parent.getBoundingClientRect();
      const aboveFold = top + window.scrollY < window.innerHeight;
      const start = aboveFold
        ? `entry ${(100 * (window.innerHeight - top)) / height}%`
        : "entry 0%";
      const end = aboveFold ? "exit 100%" : "exit 100%";

      parent.style.setProperty("--animate-scroll-range-start", start);
      parent.style.setProperty("--animate-scroll-range-end", end);
      parent.style.viewTimeline = "--animate-scroll-view-timeline block auto";
    };

    this.onResize = debounce(this.init, 200);
    window.addEventListener("resize", this.onResize);
  }

  connectedCallback() {
    if (!this.hasSupport) return;

    this.init();
  }

  disconnectedCallback() {}

  get hasSupport() {
    return "ScrollTimeline" in window;
  }
}

if (!customElements.get("animate-scroll")) {
  customElements.define("animate-scroll", AnimateScroll);
}
